import type { ParticipantTaskTemplate } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaRegCircle } from 'react-icons/fa';
import { LabelsStack } from '../../../components/generic/LabelsStack';
import { ParticipantTaskTemplateActionMenu } from './ParticipantTaskTemplateActionMenu';
import { ParticipantTaskTemplateDate } from './ParticipantTaskTemplateDate';

interface Props {
  taskTemplate: ParticipantTaskTemplate;
}

export const ParticipantTaskTemplateItem = (props: Props) => {
  const { taskTemplate } = props;

  const icon = <FaRegCircle />;
  const iconColor = 'gray.500';

  return (
    <ChakraV3.HStack align='start'>
      <ChakraV3.IconButton
        aria-label='Task status'
        variant='ghost'
        rounded='full'
        border='none'
        color={iconColor}
        size='md'
      >
        {icon}
      </ChakraV3.IconButton>

      <ChakraV3.Stack gap={1}>
        <ChakraV3.Stack gap={0}>
          <ChakraV3.Text fontSize='sm' fontWeight='semibold'>
            {taskTemplate.name}
          </ChakraV3.Text>
          <ParticipantTaskTemplateDate taskTemplate={taskTemplate} />
        </ChakraV3.Stack>
        <LabelsStack labels={taskTemplate.labels} />
      </ChakraV3.Stack>
      <ChakraV3.Spacer />
      <ChakraV3.Stack>
        <ParticipantTaskTemplateActionMenu taskTemplate={taskTemplate} />
      </ChakraV3.Stack>
    </ChakraV3.HStack>
  );
};
